//eslint-disable-next-line import/prefer-default-export
export const getBrandName = () => {
  switch (process.env.VUE_APP_BRAND_THEME) {
    case 'lawnlove':
      return 'Lawn Love';
    case 'lawnstarter':
    default:
      return 'LawnStarter';
  }
};
